import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface IncompleteSectionWrapperProps {
  isComplete: boolean
  children: ReactNode
  className?: string
}

/**
 * Wrapper component that applies amber/orange dashed border styling to incomplete sections
 * and solid white styling to complete sections
 */
export function IncompleteSectionWrapper({
  isComplete,
  children,
  className,
}: IncompleteSectionWrapperProps) {
  return (
    <div
      className={cn(
        'rounded-[40px] p-8',
        isComplete
          ? 'bg-white border border-slate-200'
          : 'bg-[rgba(245,158,11,0.02)] border-2 border-dashed border-[rgba(245,158,11,0.30)]',
        className
      )}
    >
      {children}
    </div>
  )
}
